export const environment = {
    production: true,
    apiPath: "https://api.plsrvws.net",
    intercomDomainValidations: [/getmorereviews.com/, /gmr.plsrvw.net/, /gmr.reviews.devheartbeat.net/],
    showConsole: false,
    version: "11",
    typeApp: "MULLIGAN",
    facebookAppId: "2175027109276270",
    gauthRedirectApiPath: "https://oauth-prod.plsrvw.net:8082",
    gmb_enabled: true,
    gmb_whitelist: [],
    facebookEnabled: true,
    facebook_whitelist: [],
    sentimentCheckDeprecationDate: 1664582400000,
    intercomResellerId: "5e8388ba69254e3b7e931f3e",
    freeTrialResellerId: "5e8388ba69254e3b7e931f3e",
    enabledOpenAiFeature: false,
    enabledSpamFeature: false,
    enabledContactExportFeature: false,
    enabledMultiCampaignFeature: false,
};
